/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import styled from '@emotion/styled'
import { Select as MUISelect } from '@mui/material'

export const CustomSelect = styled(MUISelect)`
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    & > svg {
        color: var(--call-for-action-color);
    }

    & > fieldset {
        border: none;
    }
`
export const HelperText = styled.span`
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.66;
    text-align: left;
    margin-top: 3px;
    margin-right: 14px;
    margin-bottom: 0;
    margin-left: 14px;
    color: #d32f2f
`
